import { render, staticRenderFns } from "./information-input.vue?vue&type=template&id=aa2eccac&scoped=true"
import script from "./information-input.vue?vue&type=script&lang=js"
export * from "./information-input.vue?vue&type=script&lang=js"
import style0 from "./information-input.vue?vue&type=style&index=0&id=aa2eccac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa2eccac",
  null
  
)

export default component.exports